export default __webpack_public_path__ + "static/font-a5857090631f15d2d0a43f307ab3505b.woff2";